<div class="contact container pt-5 pb-5">
  <div class="row">
      <div class="col-12 col-md-12">
          <div class="col-12 ps-0">
              <span>Kontakt os</span>

          </div>

          <div *ngIf="hideFormAndShowSuccessMessage === false" id="supportContactWrapper">
              <div class="kl-lightgray p-2 mt-3">
                  Felter med * skal udfyldes
              </div>

              <form class="pt-3 mb-3" [formGroup]="contactForm" (ngSubmit)="onSubmit()" #f="ngForm">
                  <div class="row">
                      <div class="pb-3 col-12 col-md-6">
                          <label for="fieldName">Navn*</label>
                          <input type="text" class="form-control" id="fieldName" formControlName="fieldName"
                          [ngClass]="{ 'invalid': (fieldName.invalid === true && fieldName.touched) || (fieldName.invalid === true && f.submitted)}">
                      </div>

                      <div class="pb-3 col-12 col-md-6">
                          <label for="email">Email*</label>
                          <input type="text" class="form-control" id="email" formControlName="email"
                          [ngClass]="{ 'invalid': (email.invalid === true && email.touched) || (email.invalid === true && f.submitted)}">
                      </div>

                      <div class="pb-3 col-12 col-md-6">
                          <label for="phoneNumber">Telefonnummer*</label>
                          <input type="text" class="form-control" id="phoneNumber" formControlName="phoneNumber" 
                          [ngClass]="{ 'invalid': (phoneNumber.invalid === true && phoneNumber.touched) || (phoneNumber.invalid === true && f.submitted)}" appNumberInput>
                      </div>

                      <div class="pb-3 col-12 col-md-6">
                          <label for="identity">Kunde- eller lodnummer</label>
                          <input type="text" class="form-control" id="identity" formControlName="identity" appNumberInput>
                      </div>

                      <div class="pb-3 col-12">
                          <label for="address">Indtast din adresse</label>
                          <input type="text" class="form-control" id="address" formControlName="address" 
                          [ngClass]="{ 'invalid': (address.invalid === true && address.touched) || (address.invalid === true && f.submitted)}">
                      </div>

                      <div class="pb-3 col-12">
                          <label for="message">Din besked*</label>
                          <textarea type="text" class="form-control" id="message" formControlName="message"
                          [ngClass]="{ 'invalid': (message.invalid === true && message.touched) || (message.invalid === true && f.submitted)}"></textarea>
                      </div>

                      <div class="pb-3 col-12">
                          <button id="submit" class="btn btn-green btn-lg mt-2" [disabled]="contactForm.invalid || isSubmitting">
                              <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              {{ isSubmitting ? 'Sender...' : 'Send besked' }}
                          </button>
                      </div>
                      <div *ngIf="showErrorMessage" class="pb-3 col-12">
                          <p class="text-danger" role="alert">Beskeden kunne ikke sendes. Prøv venligst igen.</p>
                      </div>
                  </div>
              </form>

          </div>

          <div *ngIf="hideFormAndShowSuccessMessage === true" id="messageSendSucces" class="message-responses mt-3">
              <div class="pb-3 col-12 message message-success">
                  <h1 class="text-center">
                      Tak :) Vi har modtaget din besked.
                  </h1>
                  <p class="text-center">
                      <button id="showFormButton" (click)="onSendNewMessageClick()" class="btn btn-green btn-lg mt-2">Send ny besked</button>
                  </p>
              </div>
          </div>
      </div>
  </div>
</div>
